<template>
  <div>
    <div class="filter-container">
      <div class="filter-box">
        <div class="filter-item reverse">
          <f-date-range-picker v-model="createtime" :shortcuts="[0, -7, -30]"
            @change="fetchData(1)" />
        </div>
        <div class="filter-item reverse">
          <f-equip-selector v-model="query.equipid" placeholder="设备" width="180" class="f-equip-selector"
            @change="fetchData(1)" />
        </div>
        <div class="filter-item sm reverse">
          <el-select v-model="query.event_type" class="status-select" placeholder="事件类型" clearable style="width:160px"
            @change="fetchData(1)">
            <el-option v-for="item in eventTypes" :key="item.value" :label="item.title" :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <el-table v-loading="equipLoading" ref="eventTable" :data="events" tooltip-effect="dark" max-height="630" class="padding-mini">
      <el-table-column :show-overflow-tooltip="true" label="时间" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.event_time | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
      <el-table-column width="60">
        <template slot-scope="scope">
          <f-equip-avatar :equip="scope.row" />
        </template>
      </el-table-column>
      <el-table-column label="设备" min-width="320">
        <template slot-scope="scope">
           <f-equip-name class="font-md" :equip="scope.row" />
        </template>
      </el-table-column>
      <el-table-column width="60">
        <template slot-scope="scope">
          <img v-if="scope.row.type === 'online' || scope.row.type === '上线'" class="image small-xs"
            src="@/assets/line-on.png" />
          <img v-else-if="scope.row.type === 'offline' || scope.row.type === '掉线'" class="image small-xs"
            src="@/assets/line-off.png" />
          <img v-else-if="scope.row.type === 'turnon' || scope.row.type === '开机'" class="image small-xs"
            src="@/assets/turn-on.png" />
          <img v-else-if="scope.row.type === 'turnoff' || scope.row.type === '关机'" class="image small-xs"
            src="@/assets/turn-off.png" />
          <img v-else-if="scope.row.type === 'alarmon' || scope.row.type === '告警'" class="image small-xs"
            src="@/assets/warn-on.png" />
          <img v-else-if="scope.row.type === 'alarmoff' || scope.row.type === '告警解除'" class="image small-xs"
            src="@/assets/warn-off.png" />
        </template>
      </el-table-column>
      <el-table-column prop="content" label="内容" min-width="360" />
      <div slot="append" class="mt-lg">
        <f-pagination :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" @change="fetchData" />
      </div>
      <template slot="empty">
        <div class="flex-center mt-hg" style="height:400px">
          <img src="../../../assets/no-data.png" alt="" class="no-data">
        </div>
      </template>
    </el-table>
  </div>
</template>

<script>
import { getEquipEventListApi } from "@/api/rms/rmsEventApi";
const today = new Date(new Date().toLocaleDateString()).getTime() / 1000

export default {
  name: "RmsEquipEvent",

  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      equipLoading: false,
      createtime: [today - 3600 * 24 * 30, today + 86399],
      query: {
        event_type: "",
        starttime: null,
        endtime: null,
        pindex: 1,
        equipid: null,
        psize: this.$store.state.commonStore.psize,
      },

      events: [],
      total: 0,
      eventTypes: [
        { value: 1, title: "开机", icon: "turn-on", style: "text-success" },
        { value: 2, title: "关机", icon: "turn-on", style: "text-danger" },
        { value: 3, title: "告警", icon: "tri-warning", style: "text-danger" },
        {
          value: 4,
          title: "告警解除",
          icon: "tri-warning",
          style: "text-info",
        },
        { value: 5, title: "上线", icon: "rms", style: "text-blue" },
        { value: 6, title: "掉线", icon: "rms-offline", style: "text-warning" },
      ],
    };
  },
  created() {
    this.query.starttime = today - 3600 * 24 * 30
    this.query.endtime = today + 86399
    this.fetchData();
  },

  methods: {
    fetchData(page) {
      if (page) this.query.pindex = page;
      this.createtime ? this.query.starttime = this.createtime[0] : this.query.starttime = null;
      this.createtime ? this.query.endtime = this.createtime[1] : this.query.endtime = null

      this.equipLoading = true;
      getEquipEventListApi(this.query)
        .then((res) => {
          this.equipLoading = false;
          if (res.errno === 0) {
            this.events = res.data.list;
            this.total = res.data.total;
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__header {
  padding: 0;

  .el-dialog__headerbtn {
    top: 30px;

    .el-dialog__close {
      font-size: 24px;
    }
  }
}

/deep/ .filter-container {
  padding: 10px 0;
}

.image.small-xs {
  width: 24px;
  height: 24px;
}

.no-data {
  width: 200px;
  height: 200px;
}

.f-date-range-picker,
.status-select,
.f-equip-selector {
  border-radius: 3px;
}

.foot {
  position: absolute;
  bottom: 10px;
  right: 10px;
}
</style>
